/**
 * Avatar image URLs. Humans' come from `/api/avatars/:id` (a default SVG or their upload); bots
 * share one picture. `avatar:changed` bumps a player's version so open pages fetch the new one.
 */
import { useSyncExternalStore } from 'react';

const versions = new Map<number, number>();
const listeners = new Set<() => void>();

export function bumpAvatar(playerId: number, v: number): void {
  versions.set(playerId, v);
  listeners.forEach((l) => l());
}

const subscribe = (l: () => void) => {
  listeners.add(l);
  return () => listeners.delete(l);
};

/** Bots have negative ids. */
export function avatarUrl(playerId: number, v = versions.get(playerId)): string {
  if (playerId < 0) return '/img/avatars/bot.svg';
  return `/api/avatars/${playerId}${v === undefined ? '' : `?v=${v}`}`;
}

export function useAvatarUrl(playerId: number): string {
  const v = useSyncExternalStore(subscribe, () => versions.get(playerId));
  return avatarUrl(playerId, v);
}
